












































import Vue from "vue";

import AudioElement from "@tt-app/components/exercise/common/AudioElement.vue";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import { AudioDecoderPlayer } from "@joyz/app-core/utils/audio";

export default Vue.extend({
  name: "WordSelectAnswerExplanation",
  components: { AudioElement },
  props: {
    audio: {
      type: Object,
      default: undefined
    },
    audioDecoderPlayer: {
      type: AudioDecoderPlayer,
      required: true
    },
    correct: {
      type: Boolean,
      default: true
    },
    plainText: {
      type: Array,
      default: () => []
    },
    sentence: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      icons: {
        correct: IconCorrect,
        incorrect: IconIncorrect
      }
    };
  }
});
